import React from 'react';

const CodeIcon: React.FC<{ color?: string }> = ({ color = '#4D5157' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_23540_8523)">
      <path
        d="M12 4.5L8.5 16M5 7L2 10L5 13M15 7L18 10L15 13"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_23540_8523">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CodeIcon;
